import { gatewayInstance } from "@/server/gateway";
import { MobileRecordReq } from "@/types/Mobile";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useContext } from "react";
export async function examineMobileRecord(opt: MobileRecordReq): Promise<[any, string | null]> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.reportExamineMobileRecords",
      method: "POST",
      body: opt
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 设置备注
export async function remarkSet(opt: {
  appId: string;
  userId: string;
  teamId: string;
  remark: string; // 不传或内容为空即代表删除
}): Promise<[any, string | null]> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.remark.set",
      method: "POST",
      body: opt
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function resetAvatar(): Promise<[any, string | null]> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.avatar.reset",
      method: "POST"
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}




